import { Hole, Partition, Walls } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { PositionType } from '../../../store/holeActions'
import isPartition from '../assertions/isPartition'

export function getHolePosition(
  hole: Hole,
  wall: Walls | Partition,
  positionType = 'Dentro' as PositionType,
  optional?: number,
) {
  const fondoObj = hole?.morphs.find((info) => info.name === 'Fondo')
  const holeThickness = optional ?? fondoObj?.default ?? 100
  const start = toVector3(wall.start)
  const end = toVector3(wall.end)
  const ESv = end.clone().sub(start) //Direction
  const start1 = toVector3(wall.start1)
  const end1 = toVector3(wall.end1)
  const ESv1 = start1.clone().sub(end1) //Direction 4 partitions
  const distI = hole.distI
  const offset = hole.offset

  switch (positionType) {
    case 'Interior': {
      let pos
      if (!isPartition(wall.id)) {
        pos = ESv.clone()
          .setLength(distI)
          .add(
            start.add(
              toVector3([
                (holeThickness - offset) * Math.sin(wall.rotation),
                -(holeThickness - offset) * Math.cos(wall.rotation),
              ]),
            ),
          )
      } else {
        pos = ESv1.clone().setLength(distI).add(end1)
      }
      return toVector3([pos.x, hole.y, pos.z])
    }

    case 'Exterior': {
      let pos
      if (!isPartition(wall.id)) {
        pos = ESv.clone()
          .normalize()
          .setLength(distI)
          .add(
            start.add(
              toVector3([
                (holeThickness - offset) * Math.sin(wall.rotation),
                -(holeThickness - offset) * Math.cos(wall.rotation),
              ]),
            ),
          )
      } else {
        pos = ESv1.clone().normalize().setLength(distI).add(end1)
      }
      return toVector3([pos.x, hole.y, pos.z])
    }
    default: {
      let pos
      if (!isPartition(wall.id)) {
        pos = ESv.clone()
          .normalize()
          .setLength(distI)
          .add(
            start.add(
              toVector3([
                Math.abs(holeThickness / 2 - offset) * Math.sin(wall.rotation),
                -(holeThickness / 2 - offset) * Math.cos(wall.rotation),
              ]),
            ),
          )
      } else {
        pos = ESv1.clone().normalize().setLength(distI).add(end1)
      }
      return toVector3([pos.x, hole.y, pos.z])
    }
  }
}
